import * as i0 from '@angular/core';
import { Input, ViewEncapsulation, Component, NgModule } from '@angular/core';
import { iconSizeMap } from '@engineering11/ui-lib/e11-ui-config';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@engineering11/ui-lib/e11-tooltip';
import { E11TooltipModule } from '@engineering11/ui-lib/e11-tooltip';
import { ReactiveFormsModule } from '@angular/forms';

var RequiredMode;
(function (RequiredMode) {
    RequiredMode["Optional"] = "Optional";
    RequiredMode["Required"] = "Required";
})(RequiredMode || (RequiredMode = {}));
class E11InputLabelComponent {
    set tooltipConfig(config) {
        this._tooltipConfig = config ? { ...labelTooltipDefaults, ...config } : undefined;
    }
    constructor() {
        this.label = '';
        this.size = 'sm';
        this.labelClassOverrides = '';
        this.required = false;
        this.hasError = false;
        this.disabled = false;
        this.darkMode = false;
        this.requiredMode = RequiredMode.Optional;
        this.RequiredMode = RequiredMode;
        this.labelTextOptional = '(Optional)';
        this.iconSizeMap = iconSizeMap;
    }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InputLabelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11InputLabelComponent, selector: "e11-input-label", inputs: { label: "label", id: "id", for: "for", size: "size", labelClassOverrides: "labelClassOverrides", required: "required", hasError: "hasError", disabled: "disabled", darkMode: "darkMode", requiredMode: "requiredMode", labelTextOptional: "labelTextOptional", description: "description", tooltipConfig: "tooltipConfig" }, ngImport: i0, template: `<div class="e11-flex e11-items-center">
      <div [ngClass]="{ 'e11-grow': _tooltipConfig?.tooltipPosition === 'end' }">
        <label
          *ngIf="label"
          [for]="for"
          class="e11-input-label e11-relative e11--top-1 text-{{ size }} {{ labelClassOverrides }}"
          [ngClass]="{
            'e11-text-skin-error': hasError,
            'e11-opacity-50 e11-cursor-not-allowed': disabled,
            'e11-text-skin-white': darkMode,
            'e11-mr-2': _tooltipConfig?.tooltipPosition === 'beside'
          }"
        >
          {{ label }}
          <span *ngIf="!required && requiredMode === RequiredMode.Optional" class="e11-text-skin-gray-300 e11-text-xs e11-mb-2">{{
            labelTextOptional
          }}</span>
          <span *ngIf="required && requiredMode === RequiredMode.Required" class="e11-text-skin-error e11-absolute e11--right-2">*</span>
        </label>
      </div>

      <div class="e11-flex e11-justify-end">
        <e11-tooltip *ngIf="_tooltipConfig" [color]="_tooltipConfig.color" [tooltipText]="_tooltipConfig.tooltipText">
          <span class="material-icons-outlined {{ iconSizeMap[_tooltipConfig.iconSize] }}">
            {{ _tooltipConfig.icon }}
          </span>
        </e11-tooltip>
      </div>
    </div>
    <p *ngIf="description" class="e11-mb-0 e11-text-xs" [ngClass]="{ 'e11-opacity-50': disabled,  }">
      {{ description }}
    </p> `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.E11TooltipComponent, selector: "e11-tooltip", inputs: ["tooltipText", "tooltipClassOverrides", "hideTooltip", "color", "tooltipContent", "position", "interactive", "maxWidth", "delay"], outputs: ["tooltipClick"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InputLabelComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'e11-input-label',
                    template: `<div class="e11-flex e11-items-center">
      <div [ngClass]="{ 'e11-grow': _tooltipConfig?.tooltipPosition === 'end' }">
        <label
          *ngIf="label"
          [for]="for"
          class="e11-input-label e11-relative e11--top-1 text-{{ size }} {{ labelClassOverrides }}"
          [ngClass]="{
            'e11-text-skin-error': hasError,
            'e11-opacity-50 e11-cursor-not-allowed': disabled,
            'e11-text-skin-white': darkMode,
            'e11-mr-2': _tooltipConfig?.tooltipPosition === 'beside'
          }"
        >
          {{ label }}
          <span *ngIf="!required && requiredMode === RequiredMode.Optional" class="e11-text-skin-gray-300 e11-text-xs e11-mb-2">{{
            labelTextOptional
          }}</span>
          <span *ngIf="required && requiredMode === RequiredMode.Required" class="e11-text-skin-error e11-absolute e11--right-2">*</span>
        </label>
      </div>

      <div class="e11-flex e11-justify-end">
        <e11-tooltip *ngIf="_tooltipConfig" [color]="_tooltipConfig.color" [tooltipText]="_tooltipConfig.tooltipText">
          <span class="material-icons-outlined {{ iconSizeMap[_tooltipConfig.iconSize] }}">
            {{ _tooltipConfig.icon }}
          </span>
        </e11-tooltip>
      </div>
    </div>
    <p *ngIf="description" class="e11-mb-0 e11-text-xs" [ngClass]="{ 'e11-opacity-50': disabled,  }">
      {{ description }}
    </p> `,
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: () => [], propDecorators: { label: [{
                type: Input
            }], id: [{
                type: Input
            }], for: [{
                type: Input
            }], size: [{
                type: Input
            }], labelClassOverrides: [{
                type: Input
            }], required: [{
                type: Input
            }], hasError: [{
                type: Input
            }], disabled: [{
                type: Input
            }], darkMode: [{
                type: Input
            }], requiredMode: [{
                type: Input
            }], labelTextOptional: [{
                type: Input
            }], description: [{
                type: Input
            }], tooltipConfig: [{
                type: Input
            }] } });
const labelTooltipDefaults = {
    iconSize: 'sm',
    icon: 'info',
    color: 'dark',
    tooltipPosition: 'end',
};

class E11InputLabelModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InputLabelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11InputLabelModule, declarations: [E11InputLabelComponent], imports: [CommonModule, ReactiveFormsModule, E11TooltipModule], exports: [E11InputLabelComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InputLabelModule, imports: [CommonModule, ReactiveFormsModule, E11TooltipModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InputLabelModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [E11InputLabelComponent],
                    imports: [CommonModule, ReactiveFormsModule, E11TooltipModule],
                    exports: [E11InputLabelComponent],
                    providers: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11InputLabelComponent, E11InputLabelModule, RequiredMode };
